module.exports = __webpack_public_path__ + "dlssrvtline2/img/vi-slider-2.jpg?2c1a715d";